import { createAsyncThunk } from "@reduxjs/toolkit";
import fetchWrapper from "../utils/httpClient";
import { API_DELETE_FILE, API_GET_FILE, API_UPLOAD_FILE } from "../utils/apis";

// Asynchronous thunk for fetching resources by content type
export const fetchAsset = createAsyncThunk(
  "fileUpload/fetchAsset",
  async (assetId) => {
    try {
      const response = await fetchWrapper.get(`${API_GET_FILE}/${assetId}`);

      return response.resdata;
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

export const uploadAsset = createAsyncThunk(
  "fileUpload/uploadAsset",
  async (payload) => {
    return await fetchWrapper.postFile(API_UPLOAD_FILE, payload);
  }
);

export const deleteAsset = createAsyncThunk(
  "fileUpload/deleteAsset",
  async (attachmentId) => {
    return await fetchWrapper.delete(`${API_DELETE_FILE}/${attachmentId}`);
  }
);
